<template>
  <ListView
    modelName="StockTransferItem"
    perm="stock.menu_stock_transfer_item"
    svg = "icon_side_stock_transfer_list" 
    color="steelblue"
    :items.sync="items"
    :params.sync="params"
    title="menu_stock_transfer_item"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="StockTransferItem"
    :gridCaptions="gridConfig.gridCaptions"
    :gridWidths="gridConfig.gridWidths"
    :onCreate="onCreate"
    :importQuery="importQuery"
    :exportQuery="exportQuery"
    borderColor="#61AA72"
    backColor="#EAFFEF"            
    :comparer="(a,b)=>a.id == b.id"        
    :popup="popup"                 
  >
    <!-- 明細項目の配置 -->
    <GridItem :slot="gridConfig.gridSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="stockTransferItemStatus"/></GridItem>
    <GridItem :slot="gridConfig.gridSlots[1]" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.stockTransferItemNo }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[2]" slot-scope="{ item }">{{ item.stockTransfer.transferFlag | transferTypes }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[3]" slot-scope="{ item }">{{ item.bookDate | date }}</GridItem>
    <!-- <GridItem slot="grid3" slot-scope="{ item }">{{ item.seqNo }}</GridItem> -->

    <GridItem :slot="gridConfig.gridSlots[4]" slot-scope="{ item }">{{ item.salesPurchaseFlag | stockBalanceTypes }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[5]" slot-scope="{ item }">{{ item.commodity.name }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[6]" slot-scope="{ item }">{{ item.sku == null ? "" : item.sku.name }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[7]" slot-scope="{ item }">{{ item.commodity.uom }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[8]" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale)}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[9]" slot-scope="{ item }" :right="true">{{ item.unitPrice | numeric(item.commodity.stockPriceScale) }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[10]" slot-scope="{ item }" :right="true">{{ item.amount | amount }}</GridItem>

    <GridItem :slot="gridConfig.gridSlots[11]" slot-scope="{ item }">{{ item.stockTransferNo }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[12]" slot-scope="{ item }">{{ item.stockTransfer.warehouseOut.name }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[13]" slot-scope="{ item }">{{ item.stockTransfer.warehouseIn.name }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[14]" slot-scope="{ item }">{{ item.stockTransfer.segmentOutId | segment }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[15]" slot-scope="{ item }">{{ item.stockTransfer.segmentInId | segment }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[16]" slot-scope="{ item }">{{ item.projectItem?item.projectItem.name:''}}</GridItem>      
    <GridItem :slot="gridConfig.gridSlots[17]" slot-scope="{ item }">{{ item.stockTransfer.pic | userGroup }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[18]" slot-scope="{ item }">{{ item.stockTransfer.refNo }}</GridItem>

    <!-- <GridItem slot="grid34" slot-scope="{ item, index }"><Workflow :item="item" :index="index" @updated="onWorkflow"/></GridItem> -->
    <GridItem :slot="gridConfig.gridSlots[19]" slot-scope="{ item }">{{ item.initialSavedOn | timestamp }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[20]" slot-scope="{ item }">{{ item.initialSavedBy | user }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[21]" slot-scope="{ item }">{{ item.lastUpdatedOn | timestamp }}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[22]" slot-scope="{ item }">{{ item.lastUpdatedBy | user  }}</GridItem>

    <GridItem :slot="gridConfig.gridSlots[23]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText1 == usedTypes.CommodityMemo ? item.commodity.reserveText1 : item.reserveText1)}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[24]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText2 == usedTypes.CommodityMemo ? item.commodity.reserveText2 : item.reserveText2)}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[25]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText3 == usedTypes.CommodityMemo ? item.commodity.reserveText3 : item.reserveText3)}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[26]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText4 == usedTypes.CommodityMemo ? item.commodity.reserveText4 : item.reserveText4)}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[27]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText5 == usedTypes.CommodityMemo ? item.commodity.reserveText5 : item.reserveText5)}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[28]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText6 == usedTypes.CommodityMemo ? item.commodity.reserveText6 : item.reserveText6)}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[29]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo1 == usedTypes.CommodityMemo ? item.commodity.reserveMemo1 : item.reserveMemo1)}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[30]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo2 == usedTypes.CommodityMemo ? item.commodity.reserveMemo2 : item.reserveMemo2)}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[31]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo3 == usedTypes.CommodityMemo ? item.commodity.reserveMemo3 : item.reserveMemo3)}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[32]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate1 == usedTypes.CommodityMemo ? item.commodity.reserveDate1 : item.reserveDate1)| date}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[33]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate2 == usedTypes.CommodityMemo ? item.commodity.reserveDate2 : item.reserveDate2)| date}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[34]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate3 == usedTypes.CommodityMemo ? item.commodity.reserveDate3 : item.reserveDate3)| date}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[35]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList1 == usedTypes.CommodityMemo ? item.commodity.reserveList1 : item.reserveList1 ) | category_41}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[36]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList2 == usedTypes.CommodityMemo ? item.commodity.reserveList2 : item.reserveList2 ) | category_42}}</GridItem>
    <GridItem :slot="gridConfig.gridSlots[37]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList3 == usedTypes.CommodityMemo ? item.commodity.reserveList3 : item.reserveList3 ) | category_43}}</GridItem>

    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }">
      <ListViewMenuBar :listView="listView" :add="false" :copy="false" >
      </ListViewMenuBar>
    </template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView">

        <FilterBox title="在庫振替番号" :value.sync="params.stockTransferNo" @click="handler" />
        <FilterBox title="在庫振替明細番号" :value.sync="params.stockTransferItemNo" @click="handler" />        
        <FilterBox title="管理番号" :value.sync="params.refNo" @click="handler" />        
        <ComboBox title="振替区分" :value.sync="params.transferFlag" list="transferTypes" @changed="handler" />         
        <AtcCounterpart title="出庫倉庫" :value.sync="params.warehouseOut" :needsWarehouse="true" @changed="handler" />
        <AtcCounterpart title="入庫倉庫" :value.sync="params.warehouseIn" :needsWarehouse="true" @changed="handler" />
        <AtcSegment title="出庫部門" :value.sync="params.segmentOut" @changed="handler" />
        <AtcSegment title="入庫部門" :value.sync="params.segmentIn" @changed="handler" />
        <AtcProjectItem title="案件" :value.sync="params.projectItem" @changed="handler"/>               
        <AutoComplete title="担当者" :value.sync="params.pic" list="user" @changed="handler" />      
        <AtcCommodity title="商品" :value.sync="params.commodity" @changed="handler" />
        <AtcSKU title="SKU" :value.sync="params.sku" :commodity="params.commodity" @update:value="handler" />         
        <Calendar title="発生日(From)" :value.sync="params.bookDateFrom" :deletable="true" @changed="handler" />
        <Calendar title="発生日(To)" :value.sync="params.bookDateTo" :deletable="true" @changed="handler" />

        <Calendar title="初回保存日(From)" :value.sync="params.initialSavedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(To)" :value.sync="params.initialSavedOnTo" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(From)" :value.sync="params.lastUpdatedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(To)" :value.sync="params.lastUpdatedOnTo" :deletable="true" @changed="handler" />
        <AutoComplete title="所有者" :value.sync="params.holder" list="user" @changed="handler" />           
        <ComboBox title="状態" :value.sync="params.state" list="stockTransferItemStatus" @changed="handler" />
        <!-- <ComboBox title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> -->
      </Search>
    </template>
    <!-- フルサイズエディタの配置(ListView:fullSizeEditor="true"を指定) -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報','予備項目','更新履歴']">
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">
              <TextBox title="明細番号" :value="item.stockTransferItemNo" :editor="editor" :enabled="false" tooltip="在庫振替番号に紐づく明細番号が初回保存時に自動で付与されます。" />
              <!-- <TextBox title="行番号" :value="item.seqNo" :editor="editor" :enabled="false" /> -->
              <Calendar title="発生日" :value="item.bookDate" :editor="editor" :enabled="false" tooltip="【在庫一覧】の在庫振替子画面で指定された発生日です。" />              
              <TextBox title="入出庫区分" :value="item.salesPurchaseFlag | stockBalanceTypes" :editor="editor" :enabled="false" tooltip="振替の入出庫区分です。１度の在庫振替で、明細ごとに【入庫】【出庫】が分かれて表示されます。" />
              <AtcCommodity title="商品" :value="item.commodity" :editor="editor" :enabled="false" tooltip="在庫振替を行う商品です。変更する場合は改めて在庫振替を行ってください。" />
              <AtcSKU title="SKU" :value="item.sku" :editor="editor" :commodity="item.commodity" :enabled="false" tooltip="在庫振替を行う商品のSKUです。変更する場合は改めて在庫振替を行ってください。" />
              <TextBox title="単位" :value="item.commodity.uom" :editor="editor" :enabled="false" tooltip="在庫振替を行う商品の　【計上単位】です。" />
              <NumericBox title="振替数量" :value.sync="item.quantity" :editor="editor" :required="true" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" more="0" max="99999999.999" :nullValue="0" :enabled="isEditableQuantity(item)" @update:value="setTransferQuantity(item)" tooltip="在庫振替を行う数量です。【入出庫区分】が【入庫】の場合は在庫に加算されます。【出庫】の場合は在庫から減算されます。" />
              <NumericBox title="振替単価" :value.sync="item.unitPrice" :editor="editor" :required="true" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" more="0" max="99999999999.999999" :nullValue="0" :enabled="isEditablePrice(item)" @update:value="setTransferPrice(item)" tooltip="在庫振替を行う際に設定される単価です。商品の在庫金額に影響します。" />
              <NumericBox title="振替金額" :value.sync="item.amount" :editor="editor" :required="true" :decimals="$api.systemCurrencyPrecision" more="0" max="99999999999.99" :nullValue="0" :enabled="isEditableAmount(item)" @update:value="setTransferAmount(item)" tooltip="在庫振替を行う際に設定される金額です。【振替数量】×【振替単価】で算出されます。" />

            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">
              <div class="cx_controls">
                <TextBox title="在庫振替番号" :value="item.stockTransferNo" :enabled="false" :linkFormat="getStockTransferLinkFormat(item)" tooltip="在庫振替の初回保存時に自動で付与された番号です。" />              
                <TextBox title="管理番号" :value="item.stockTransfer.refNo" :editor="editor" :enabled="false" tooltip="在庫振替の管理番号が表示されています。在庫振替明細一覧からの変更は出来ません。" />                            
              </div>
              <AtcCounterpart title="出庫倉庫" :value="item.stockTransfer.warehouseOut" :editor="editor" :needsWarehouse="true" :enabled="false" tooltip="在庫の振替元倉庫です。在庫振替処理が行われた在庫の倉庫です。" />
              <AtcCounterpart title="入庫倉庫" :value="item.stockTransfer.warehouseIn" :editor="editor" :needsWarehouse="true" :enabled="false" tooltip="在庫の振替先倉庫です。在庫移動で設定されている入庫倉庫です。" />
              <AtcSegment title="出庫部門" :value=" item.stockTransfer.segmentOut" :editor="editor" :enabled="false" tooltip="在庫の振替元部門です。在庫振替処理が行われた在庫の部門です。" />
              <AtcSegment title="入庫部門" :value="item.stockTransfer.segmentIn" :editor="editor" :enabled="false" tooltip="在庫の振替先部門です。在庫移動で設定されている入庫部門です。" />
              <AtcProjectItem title="案件" :value.sync="item.projectItem" :editor="editor"  :enabled="false"/>                        
              <AutoComplete title="担当者" :value="item.stockTransfer.pic" :editor="editor" list="user" :enabled="false" tooltip="在庫振替の担当者が表示されています。在庫振替明細一覧からの変更は出来ません。" />
              <!-- <TextBox title="所有者" :value="item.holder" :editor="editor" :enabled="false" /> -->
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false" tooltip="在庫振替情報を最後に編集した日時が表示されています。" />                      
              <!-- <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_stockTransferItem" :required="$api.perms.hasWorkflow('stockTransferItem')" :enabled="$api.perms.hasWorkflow('stockTransferItem') && $api.perms.isEntryStatus(item)" :nullValue="0" /> -->
              <TextBox title="状態" :value="$api.perms.getStateLabel(item,'stockTransferItemStatus')" :enabled="false" tooltip="在庫振替情報の現在の状態です。" />    

            </template>
          </EditPanel>
        </template>
        <!-- 更新履歴タブ -->
        <template slot="tab1" slot-scope="{ item,editor }">
          <PnlReserveItems :item="item" :editor="editor" :enabled="false" :commodityAttribute="visibleTypes.ReadOnly" :stockAttribute="visibleTypes.Editable"  :orderMemo="visibleTypes.ReadOnly" :deliveryMemo="visibleTypes.Editable" :commodity="item.commodity" /> 
        </template>        
        <!-- 更新履歴タブ -->
        <template slot="tab2" slot-scope="{ item }">
          <AuditLog :auditName="item.auditName" :auditNo="item.auditNo" />
        </template>
      </Editor>
    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';
import { Currency, GetSystemCurrecy, RoundTypes } from '@/tenant/models/All';

@Component
export default class StockTakingItemView extends Vue {
  public items: Common.StockTransferItem[] = new Array(0);
  public params: Common.StockTransferItemQuery = new Common.StockTransferItemQuery();
  public importQuery = new Common.ImportQuery('在庫振替明細','StockTransferItem');
  public exportQuery = new Common.StockTransferItemExportQuery('在庫振替明細',this.params);
    public usedTypes = Common.UsedTypes;
  public sortOptions: any = [
    { value: 'state', text: '状態' },
    { value: 'stockTransferItemNo', text: '明細番号' },
    { value: 'transferFlag', text: '振替区分' },
    { value: 'bookDate', text: '発生日' },
    { value: 'salesPurchaseFlag', text: '入出庫区分' },
    { value: 'commodity', text: '商品' },
    { value: 'stockTransferNo', text: '在庫振替番号' },
    { value: 'warehouseOut', text: '出庫倉庫' },
    { value: 'warehouseIn', text: '入庫倉庫' },
    { value: 'segmentOut', text: '出庫部門' },
    { value: 'segmentIn', text: '入庫部門' },
    { value: 'pic', text: '担当者' },
    { value: 'refNo', text: '管理番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  @Prop() public stockTransferNo:string;
  @Prop() public stockTransferItemNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor; 

  public savingFlag: Common.StockBalanceJournalStatus = Common.StockBalanceJournalStatus.StockTransferWaiting;
  public visibleTypes = Common.visibleTypes;  
  public tenantSettings: Common.TenantSettings = null;  
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');

  public created() {

    this.tenantSettings = this.$api.tenantSettings;
    this.gridConfig.setGridItemsFromCaptions(
      [ '状態','明細番号', '振替区分','発生日',  '入出庫区分', '商品','SKU', '単位',  '振替数量', '振替単価', '振替金額', '在庫振替番号', '出庫倉庫',  '入庫倉庫', '出庫部門','入庫部門','案件','担当者', '管理番号', '初回保存日', '初回保存者', '最終更新日', '最終更新者'],
      [150, 180, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150,150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150, 150]
    );
    this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,true,false,false));
    // 検索条件を設定する
    if(this.stockTransferNo){
      this.params.stockTransferNo = this.stockTransferNo;
      this.params.state = null;
    }
    if(this.stockTransferItemNo) {
      this.params.stockTransferItemNo = this.stockTransferItemNo;
      this.params.state = null;
    }
    if(!this.stockTransferNo && !this.stockTransferItemNo){
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
            
  }

  public async onCreate(obj: Common.StockTakingItem) {
    // const workflows = this.$api.formatter.getOptions('workflow_stockTransferItem');
    // if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  // 在庫振替一覧へ遷移する
  public getStockTransferLinkFormat(item : Common.StockTransferItem){
    return '/journal/StockTransfer?stockTransferNo={0}';
  }

  // 振替数量の活性制御
  public isEditableQuantity(item:Common.StockTransferItem):boolean{
    if(item.state == this.savingFlag && item.stockTransfer.transferFlag == Common.TransferTypes.Transfer) return true;
    return false;
  }

  // 振替数量変更時の項目設定
  public setTransferQuantity(item:Common.StockTransferItem){
    if(item.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales) {
      item.amount = new Common.CalcUtil().Round(item.unitPrice * item.quantity,this.$api.systemCurrencyPrecision,this.$api.systemCurrencyRoundType);
    }
    else
    {
      if(item.quantity == 0) item.unitPrice = 0;
      else item.unitPrice = new Common.CalcUtil().Round(item.amount / item.quantity, item.commodity.stockPriceScale, item.commodity.stockPriceRound);
    }
  }

  // 振替単価の活性制御
  public isEditablePrice(item:Common.StockTransferItem):boolean{
    if(item.state == this.savingFlag && item.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales) return true;
    return false;
  }

  // 振替単価変更時の項目設定
  public setTransferPrice(item:Common.StockTransferItem){
    if(item.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales) 
      item.amount = new Common.CalcUtil().Round(item.unitPrice * item.quantity,this.$api.systemCurrencyPrecision,this.$api.systemCurrencyRoundType);
  }

  // 振替金額の活性制御
  public isEditableAmount(item:Common.StockTransferItem):boolean{
    if(item.state == this.savingFlag && item.salesPurchaseFlag == Common.SalesPurchaseFlags.Purchase) return true;
    return false;
  }

  // 振替金額変更時の項目設定
  public setTransferAmount(item:Common.StockTransferItem){
    if(item.salesPurchaseFlag == Common.SalesPurchaseFlags.Purchase) 
    {
      if(item.quantity == 0) item.unitPrice = 0;
      else item.unitPrice = new Common.CalcUtil().Round(item.amount / item.quantity, item.commodity.stockPriceScale, item.commodity.stockPriceRound);
    }
  }
}
</script>